import React from 'react';
import expiry_pic from '../../images/Expired_pic.png'

const LinkExpiryPage = () => (
  <div>
    <div className='text-center'>
      <div className='mb-4'>
        <img src={expiry_pic} />
      </div>
      <h3 className='mb-4'>Sorry, the link has expired</h3>
      <p>Please contact the person who shared the link with you.</p>
    </div>
  </div>
);

export default LinkExpiryPage;
